import React, { FC } from "react";
import { Button, Icon, Image, Flex, Text } from "@chakra-ui/react";
import laptopMagnifier from "@/assets/studentTile/laptop-magnifier.svg?url";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import InactiveTileContentLayout from "@/js/components/StudentTile/components/inactiveScreenStates/InactiveTileContentLayout";

interface StudentTileRetryAvailableProps {
	useScreenshotRetry: () => void;
}

const StudentNoActivityDetected: FC<StudentTileRetryAvailableProps> = (props: StudentTileRetryAvailableProps) => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			<Image src={laptopMagnifier} htmlHeight={42} htmlWidth={42} />
			<InactiveTileContentLayout>
				<Text fontWeight={"bold"}>No activity detected</Text>
				{tileSize !== "sm" && <Text>If the student is using their device, we can retry connecting</Text>}
			</InactiveTileContentLayout>
			<Button size="sm" py={0} px={4} mb={tileSize === "lg" ? 4 : 0} mt={"auto"} onClick={() => props.useScreenshotRetry()} fontSize={12}>
				<Icon fontSize={8} className={"fa-solid fa-refresh"} mr={2} /> {"Retry connecting"}
			</Button>
		</Flex>
	);
};

export default StudentNoActivityDetected;
